import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgPlusLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M23 12.0007H1M12 1.00073V23.0007"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgPlusLarge.displayName = 'SvgPlusLarge';
const PlusLarge = withForgeIconProps(SvgPlusLarge, {
  name: 'Plus',
  usage: 'Use to adjust or increment up.',
  related: 'add',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'large',
});
export default PlusLarge;
